import React, {Component, PropTypes} from 'react';
import {
  Button,
  Modal,
  Checkbox,
} from '@sketchpixy/rubix';

import {updatePatientInfo} from '../../api/api';

class ChangePatientInfoModal extends Component {
  constructor(props) {
    super(props);

    let patientId    = props.patientId;
    this.state = {patientId, patientEmail: '', patientMobileNo: '', buyerMobileNo: '', enableSerialLogin: false, resetUserValidation:false};
  }

  componentWillReceiveProps(nextProps) {
    let patientId         = nextProps.patientId;
    let patientEmail      = nextProps.patientEmail;
    let patientMobileNo   = nextProps.patientMobileNo;
    let buyerMobileNo     = nextProps.buyerMobileNo;
    let enableSerialLogin = nextProps.enableSerialLogin;

    this.setState({patientId, patientEmail, patientMobileNo, buyerMobileNo, enableSerialLogin});
  }

  emailChangeHandler = (event) => {
    let patientEmail = event.target.value;
    this.setState({patientEmail});
  };

  patientMobileNoChangeHandler = (event) => {
    let patientMobileNo = event.target.value;
    this.setState({patientMobileNo});
  };

  buyerMobileNoChangeHandler = (event) => {
    let buyerMobileNo = event.target.value;
    this.setState({buyerMobileNo});
  };

  serialLoginChangeHandler = (event) => {
    this.setState({enableSerialLogin:!this.state.enableSerialLogin});
  };

  resetUserValidationChangeHandler = (event) => {
    this.setState({resetUserValidation:!this.state.resetUserValidation});
  };


  updateEmail = () => {
    updatePatientInfo(this.state, (err, result) => {
      if (err) {
        Messenger().post({
          type: 'error',
          message: `${err.message} (${err.statusCode})`,
          showCloseButton: true,
        });
      } else {
        if (result.statusCode === "0" || result.statusCode === 0) {
          this.props.closeModal(true);
        } else {
          this.props.closeModal(true);
          Messenger().post({
            type: 'error',
            message: result.statusMessage,
            showCloseButton: true,
          });
        }
      }
    });
  };


  render() {
    return (
        <Modal
            show={this.props.showModal}
            onHide={this.props.closeModal}
            backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>Change Patient Info</Modal.Title>
          </Modal.Header>
          <Modal.Body>
	          <div className="container-fluid">
                <form role="form">
                  <div className="row">
   	                <div className="col-md-6">
	                  <div className="form-group">
	                    <label htmlFor="patientEmail">Patient Email address</label>
	                    <input type="email" className="form-control" id="patientEmail"  onChange={this.emailChangeHandler} value={this.state.patientEmail} maxLength={30}/>
	                  </div>
	               </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="patientMobileNo">Patient Mobile No</label>
                        <input type="text" className="form-control" id="patientMobileNo"  onChange={this.patientMobileNoChangeHandler} value={this.state.patientMobileNo} maxLength={15}/>
                      </div>
                    </div>
	              </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="buyerMobileNo">Buyer Mobile No</label>
                        <input type="text" className="form-control" id="buyerMobileNo"  onChange={this.buyerMobileNoChangeHandler} value={this.state.buyerMobileNo} maxLength={15}/>
                      </div>
                    </div>
                    <div className="col-md-6">
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="enableSerialLogin">Serial Login</label>
                        <Checkbox checked={this.state.enableSerialLogin} onChange={this.serialLoginChangeHandler} />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="resetUserValidation">Reset User Login Validation</label>
                        <Checkbox checked={this.state.resetUserValidation} onChange={this.resetUserValidationChangeHandler} />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
          </Modal.Body>
          <Modal.Footer>
            <Button className="btn btn-primary" onClick={this.updateEmail}>Save</Button>
            <Button onClick={this.props.closeModal}>Cancel</Button>
          </Modal.Footer>
        </Modal>
    );
  }
}

ChangePatientInfoModal.propTypes = {
  showModal:         PropTypes.bool.isRequired,
  closeModal:        PropTypes.func.isRequired,
  patientId:         PropTypes.number.isRequired,
  patientEmail:      PropTypes.string,
  patientMobileNo:   PropTypes.string,
  buyerMobileNo:     PropTypes.string,
  enableSerialLogin: PropTypes.bool
};

export default ChangePatientInfoModal;



// WEBPACK FOOTER //
// ./src/routes/patient/ChangePatientInfoModal.js